import type { ReactElement } from 'react';
import { useInstanceMarkers } from '../hooks/portal/useInstanceMarkers';
import { collectInstanceIds } from '../portal/resolveInstanceMarkers';

type ResolveInstanceMarkersProps<T> = {
  value: T;
  render: (resolved: T) => ReactElement | null;
};

const Resolved = <T,>({ value, render }: ResolveInstanceMarkersProps<T>) => render(useInstanceMarkers(value));

/**
 * For what cannot take a node — a chart tooltip, an axis tick — the deployment's name as a string.
 * Anything that can host one shows an `InstanceBadge` instead.
 *
 * Only a value that actually names a deployment mounts the resolving branch, so a marker-free
 * widget still renders without the portal chain and the `AuthProvider` behind it.
 */
export const ResolveInstanceMarkers = <T,>({ value, render }: ResolveInstanceMarkersProps<T>) =>
  collectInstanceIds(value).length > 0 ? <Resolved value={value} render={render} /> : render(value);
